import React, {PureComponent} from 'react'
import c from 'classnames'

import './style'
import './media'

/*IMG*/
import Img from 'components/Img'

/*MODAL*/
import Modal from 'components/Modal'

/*HELPERS*/
import { IsIsset } from 'helpers/ValueTests'

/*IMG*/
import ArrowRightIcon from "./images/arrow-right.svg"

/*CORES*/
import AppCore from 'cores/AppCore'

class DoctorAnswerCard extends PureComponent {
    state = {
        open: false,
        bigText: false,
        mouseDown: "",
    }

    // isAnswerTextNeedCut = (text = "") => {
    //     const width = window.innerWidth
    //
    //     if (width <= 380 && text.length >= 148) {
    //         return 148
    //
    //     } else if (width <= 350 && text.length >= 140) {
    //         return 140
    //
    //     } else if (width <= 430 && text.length >= 130) {
    //         return 130
    //
    //     } else if (width <= 550 && text.length >= 160) {
    //         return 160
    //
    //     } else if (width <= 600 && text.length >= 220) {
    //         return 220
    //     } else if (width > 600 && text.length >= 240) {
    //         return 240
    //     }
    //
    //     return false
    // }

    // getAnswerText = (text) => {
    //     const needCut = this.isAnswerTextNeedCut(text)
    //
    //     if (needCut !== false) {
    //         return text.substr(0, needCut)
    //     }
    //
    //     return text
    // }

    initTextContent = (node) => {
        if (node) {
            if (node.offsetHeight > node.parentNode.offsetHeight) {
                this.setState({
                    bigText: true
                })
            }
        }
    }

    handleMouseDown = (e) => {
        this.setState({
            mouseDown: e.clientX
        })
    }

    handleClick = (e) => {
        const { answer = "", question = "" } = this.props

        //let needCut = this.isAnswerTextNeedCut(answer+question)

        if (
            e.clientX + 10 >= this.state.mouseDown &&
            e.clientX - 10 <= this.state.mouseDown &&
            this.state.bigText == true
            //needCut !== false
        ) {
            this.setState({
                open: true
            })
        }
    }

    handleCloseModal = () => {
        this.setState({
            open: false
        })
    }

    render() {
        const { props = {} } = this
        const small = props.question.length >= 45

        const { answer: questionAnswer = "", question = "" } = props

        //let needCut = this.isAnswerTextNeedCut(questionAnswer+question)

        const { open, bigText = false } = this.state

        const text = props.answer

        if (!IsIsset(text)) {
            return null
        }

        const answer = (
            <div
                className={c( "doctor-answer-card", props.className )}
                onMouseDown={this.handleMouseDown}
                onClick={this.handleClick}
            >
                <div className="wrapper">
                    <div className="close-btn">&times;</div>
                    <div className="question-block">
                        <div className="info-row">
                            <div className="user">
                                {props.avatar}
                            </div>

                            <div className="date-question">
                                {props.dateQuestion}
                            </div>
                        </div>

                        <div className={c( "question", { small })}>
                            <div className="question__title">
                                {props.question}
                            </div>
                            { IsIsset(props.description) && <div className="question__text">
                                {props.description}
                            </div> }
                        </div>   
                    </div>

                    <div className="answer-block">
                        <div className={c("answer", { "big-text": bigText })}>
                            <div className="text-content" ref={this.initTextContent}>
                                {text}
                            </div>
                        </div>

                        <div className="bottom-row">
                            <div className="date-answer">
                                {props.dateAnswer}
                            </div>
                            { bigText && <div className="read-more">
                                <span>
                                    {AppCore.Interfaces.t( "DoctorLanding.Ui.AnswerCard.Index.ShowAllText" ) }
                                </span>
                                <Img src={ArrowRightIcon}/>
                            </div> }
                        </div>
                    </div>
                </div>
            </div>
        )

        const modal = <Modal
            className="modal-doctor-answer"
            isOpen={open}
            onRequestClose={this.handleCloseModal}
        >
            {answer}
        </Modal>

        return <>
            {answer}

            {modal}
        </>
    }
}

export default DoctorAnswerCard











